export default "__VITE_ASSET__69c3fd2a__"